// extracted by mini-css-extract-plugin
module.exports = {"separator":"SegmentSeparator-module--separator--2i8xy"};